export * from './TopicsBlock';

import { TopicsBlock } from './TopicsBlock';

export default TopicsBlock;
